<template>
  <div>
    <select class="form-control" :id="id" :name="name" :disabled="disabled" :required="required"></select>
  </div>
</template>

<style>
/* .select2  --- it's copy from file style.css because need rearange with default css insertions */
.select2-container--default .select2-selection--multiple {
    height: 163px;
    background: #FFF;
    border: 1px solid #E3E3E4;
    border-radius: 8px;
    padding-top: 3px;
    padding-left: 3px;
    padding-bottom: 8px;
    padding-right: 8px;
}

.select2-container--default.select2-container--focus .select2-selection--multiple {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
}

.select2-container--default .select2-selection--multiple .select2-selection__choice {
    font-family: inherit;
    background: #F6F6F6;
    border-radius: 8px;
    border: none;
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 8px;
    padding-right: 24px;
    color: #525658;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
    left: auto;
    right: 0;
    bottom: 0;
    border: none;
    font-size: 0;
    width: 22px;
}
.select2-container--default .select2-selection--multiple .select2-selection__choice__remove:before,
.select2-container--default .select2-selection--multiple .select2-selection__choice__remove:after {
    content: "";
    border-top: 1px solid #828586;
    width: 8px;
    position: absolute;
    left: 6px;
    top: 18px;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice__remove:before {
    transform: rotate(45deg);
}
.select2-container--default .select2-selection--multiple .select2-selection__choice__remove:after {
    transform: rotate(-45deg);
}

.select2-container--default .select2-search--inline .select2-search__field {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 8px;
    padding-right: 8px;
    color: #525658;
    font-family: inherit;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    height: 36px;
    min-width: 50px;
}

.select2-dropdown {
    background: #FFF;
    box-shadow: 3px 1px 32px rgba(24, 29, 32, 0.05);
    border-radius: 6px;
    border: none;
    padding: 4px;
    margin-top: 4px;
}

.select2-results__option {
    font-family: inherit;
    color: #525658;
    font-weight: 500;
    font-size: 14px;
    border-radius: 6px;
    transition: background .2s linear;
}

.select2-container--default .select2-results__option--selected {
    background: #F6F6F6;
}

.select2-container--default .select2-results__option--highlighted.select2-results__option--selectable {
    background: #1A8FE3;
}
.select-font-block span.select2 {
    width: 100% !important;
}
</style>

<script>
import $ from 'jquery';
import 'select2/dist/js/select2.full';
import 'select2/dist/css/select2.min.css'

export default {
  name: 'Select2',
  data() {
    return {
      select2: null
    };
  },
  model: {
    event: 'change',
    prop: 'value'
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    settings: {
      type: Object,
      default: () => {}
    },
    value: null
  },
  watch: {
    options(val) {
      this.setOption(val);
    },
    value(val) {
      this.setValue(val);
    }
  },
  methods: {
    setOption(val = []) {
      this.select2.empty();
      this.select2.select2({
        placeholder: this.placeholder,
        ...this.settings,
        data: val
      });
      this.setValue(this.value);
    },
    setValue(val) {
      if (val instanceof Array) {
        this.select2.val([...val]);
      } else {
        this.select2.val([val]);
      }
      this.select2.trigger('change');
    }
  },
  mounted() {
    this.select2 = $(this.$el)
      .find('select')
      .select2({
        placeholder: this.placeholder,
        ...this.settings,
        data: this.options
      })
      .on('select2:select select2:unselect', ev => {
        this.$emit('change', this.select2.val());
        this.$emit('select', ev['params']['data']);
      })
      .on('select2:closing', ev => {
        this.$emit('closing', ev);
      })
      .on('select2:close', ev => {
        this.$emit('close', ev);
      })
      .on('select2:opening', ev => {
        this.$emit('opening', ev);
      })
      .on('select2:open', ev => {
        this.$emit('open', ev);
      })
      .on('select2:clearing', ev => {
        this.$emit('clearing', ev);
      })
      .on('select2:clear', ev => {
        this.$emit('clear', ev);
      });
    this.setValue(this.value);
  },
  beforeDestroy() {
    this.select2.select2('destroy');
  }
};
</script>
